export const eyeWithDotGray = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="16"
    viewBox="0 0 22 16"
    fill="none"
  >
    {/* Outer eye shape */}
    <path
      d="M21.5191 7.66187C20.6737 5.47518 19.2061 3.58413 17.2977 2.22244C15.3893 0.860743 13.1237 0.0880993 10.7809 0C8.43819 0.0880993 6.1726 0.860743 4.26418 2.22244C2.35577 3.58413 0.888185 5.47518 0.0428192 7.66187C-0.0142731 7.81979 -0.0142731 7.99271 0.0428192 8.15063C0.888185 10.3373 2.35577 12.2284 4.26418 13.5901C6.1726 14.9518 8.43819 15.7244 10.7809 15.8125C13.1237 15.7244 15.3893 14.9518 17.2977 13.5901C19.2061 12.2284 20.6737 10.3373 21.5191 8.15063C21.5762 7.99271 21.5762 7.81979 21.5191 7.66187Z"
      fill="#6A7282"
    />

    {/* Inner white circle (eye sclera, creates gap) */}
    <circle cx="11" cy="8" r="3" fill="white" />

    {/* Central dark pupil */}
    <circle cx="11" cy="8" r="1.3" fill="#6A7282" />
  </svg>
);

export const editgray = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M10.2969 2.5H4.46354C4.02151 2.5 3.59759 2.67559 3.28503 2.98816C2.97247 3.30072 2.79688 3.72464 2.79688 4.16667V15.8333C2.79688 16.2754 2.97247 16.6993 3.28503 17.0118C3.59759 17.3244 4.02151 17.5 4.46354 17.5H16.1302C16.5722 17.5 16.9962 17.3244 17.3087 17.0118C17.6213 16.6993 17.7969 16.2754 17.7969 15.8333V10"
      stroke="#6A7282"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.6101 2.18769C15.9416 1.85617 16.3913 1.66992 16.8601 1.66992C17.3289 1.66992 17.7786 1.85617 18.1101 2.18769C18.4416 2.51921 18.6279 2.96885 18.6279 3.43769C18.6279 3.90653 18.4416 4.35617 18.1101 4.68769L10.5993 12.1994C10.4014 12.3971 10.1569 12.5418 9.88844 12.6202L7.49427 13.3202C7.42256 13.3411 7.34655 13.3424 7.2742 13.3238C7.20184 13.3053 7.13579 13.2676 7.08298 13.2148C7.03016 13.162 6.99251 13.096 6.97397 13.0236C6.95544 12.9512 6.95669 12.8752 6.9776 12.8035L7.6776 10.4094C7.75638 10.1411 7.90138 9.8969 8.09927 9.69936L15.6101 2.18769Z"
      stroke="#6A7282"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const clickIcon = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.875C8.39303 1.875 6.82214 2.35152 5.486 3.24431C4.14985 4.1371 3.10844 5.40605 2.49348 6.8907C1.87852 8.37535 1.71762 10.009 2.03112 11.5851C2.34463 13.1612 3.11846 14.6089 4.25476 15.7452C5.39106 16.8815 6.8388 17.6554 8.4149 17.9689C9.99099 18.2824 11.6247 18.1215 13.1093 17.5065C14.594 16.8916 15.8629 15.8502 16.7557 14.514C17.6485 13.1779 18.125 11.607 18.125 10C18.1227 7.84581 17.266 5.78051 15.7427 4.25727C14.2195 2.73403 12.1542 1.87727 10 1.875ZM10 16.875C8.64026 16.875 7.31105 16.4718 6.18046 15.7164C5.04987 14.9609 4.16868 13.8872 3.64833 12.6309C3.12798 11.3747 2.99183 9.99237 3.2571 8.65875C3.52238 7.32513 4.17716 6.10013 5.13864 5.13864C6.10013 4.17716 7.32514 3.52237 8.65876 3.2571C9.99238 2.99183 11.3747 3.12798 12.631 3.64833C13.8872 4.16868 14.9609 5.04987 15.7164 6.18045C16.4718 7.31104 16.875 8.64025 16.875 10C16.8729 11.8227 16.1479 13.5702 14.8591 14.8591C13.5702 16.1479 11.8227 16.8729 10 16.875ZM15 10C15 10.1658 14.9342 10.3247 14.8169 10.4419C14.6997 10.5592 14.5408 10.625 14.375 10.625H10C9.83424 10.625 9.67527 10.5592 9.55806 10.4419C9.44085 10.3247 9.375 10.1658 9.375 10V5.625C9.375 5.45924 9.44085 5.30027 9.55806 5.18306C9.67527 5.06585 9.83424 5 10 5C10.1658 5 10.3247 5.06585 10.4419 5.18306C10.5592 5.30027 10.625 5.45924 10.625 5.625V9.375H14.375C14.5408 9.375 14.6997 9.44085 14.8169 9.55806C14.9342 9.67527 15 9.83424 15 10Z"
      fill="#232323"
    />
  </svg>
);

export const eyeIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_3996_28929)">
      <path
        d="M1.3335 7.99992C1.3335 7.99992 3.3335 3.33325 8.00016 3.33325C12.6668 3.33325 14.6668 7.99992 14.6668 7.99992C14.6668 7.99992 12.6668 12.6666 8.00016 12.6666C3.3335 12.6666 1.3335 7.99992 1.3335 7.99992Z"
        stroke="#50869A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
        stroke="#50869A"
        stroke-width="1.33333"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3996_28929">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const orangeFileIcon = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17 21H7M17 21H17.803C18.921 21 19.48 21 19.907 20.782C20.284 20.59 20.59 20.284 20.782 19.908C21 19.481 21 18.921 21 17.803V9.22C21 8.77 21 8.545 20.952 8.331C20.9094 8.14009 20.8389 7.95647 20.743 7.786C20.637 7.596 20.487 7.431 20.193 7.104L17.438 4.042C17.097 3.664 16.924 3.472 16.717 3.334C16.5303 3.21013 16.3241 3.11853 16.107 3.063C15.863 3 15.6 3 15.075 3H6.2C5.08 3 4.52 3 4.092 3.218C3.71569 3.40974 3.40974 3.71569 3.218 4.092C3 4.52 3 5.08 3 6.2V17.8C3 18.92 3 19.48 3.218 19.907C3.41 20.284 3.715 20.59 4.092 20.782C4.519 21 5.079 21 6.197 21H7M17 21V17.197C17 16.079 17 15.519 16.782 15.092C16.59 14.7155 16.2837 14.4096 15.907 14.218C15.48 14 14.92 14 13.8 14H10.2C9.08 14 8.52 14 8.092 14.218C7.71569 14.4097 7.40974 14.7157 7.218 15.092C7 15.52 7 16.08 7 17.2V21M15 7H9"
      stroke="#F97316"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const enrollPatient = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 4C7.93913 4 6.92172 4.42143 6.17157 5.17157C5.42143 5.92172 5 6.93913 5 8C5 9.06087 5.42143 10.0783 6.17157 10.8284C6.92172 11.5786 7.93913 12 9 12C10.0609 12 11.0783 11.5786 11.8284 10.8284C12.5786 10.0783 13 9.06087 13 8C13 6.93913 12.5786 5.92172 11.8284 5.17157C11.0783 4.42143 10.0609 4 9 4ZM7 13C5.93913 13 4.92172 13.4214 4.17157 14.1716C3.42143 14.9217 3 15.9391 3 17V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H13C13.5304 20 14.0391 19.7893 14.4142 19.4142C14.7893 19.0391 15 18.5304 15 18V17C15 15.9391 14.5786 14.9217 13.8284 14.1716C13.0783 13.4214 12.0609 13 11 13H7ZM15 12C15 11.7348 15.1054 11.4804 15.2929 11.2929C15.4804 11.1054 15.7348 11 16 11H17V10C17 9.73478 17.1054 9.48043 17.2929 9.29289C17.4804 9.10536 17.7348 9 18 9C18.2652 9 18.5196 9.10536 18.7071 9.29289C18.8946 9.48043 19 9.73478 19 10V11H20C20.2652 11 20.5196 11.1054 20.7071 11.2929C20.8946 11.4804 21 11.7348 21 12C21 12.2652 20.8946 12.5196 20.7071 12.7071C20.5196 12.8946 20.2652 13 20 13H19V14C19 14.2652 18.8946 14.5196 18.7071 14.7071C18.5196 14.8946 18.2652 15 18 15C17.7348 15 17.4804 14.8946 17.2929 14.7071C17.1054 14.5196 17 14.2652 17 14V13H16C15.7348 13 15.4804 12.8946 15.2929 12.7071C15.1054 12.5196 15 12.2652 15 12Z"
      fill="white"
    />
  </svg>
);

export const historyCCM = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 21C9.9 21 8.04167 20.3627 6.425 19.088C4.80833 17.8133 3.75833 16.184 3.275 14.2C3.20833 13.95 3.25833 13.721 3.425 13.513C3.59167 13.305 3.81667 13.184 4.1 13.15C4.36667 13.1167 4.60833 13.1667 4.825 13.3C5.04167 13.4333 5.19167 13.6333 5.275 13.9C5.675 15.4 6.5 16.625 7.75 17.575C9 18.525 10.4167 19 12 19C13.95 19 15.6043 18.321 16.963 16.963C18.3217 15.605 19.0007 13.9507 19 12C18.9993 10.0493 18.3203 8.39533 16.963 7.038C15.6057 5.68067 13.9513 5.00133 12 5C10.85 5 9.775 5.26667 8.775 5.8C7.775 6.33333 6.93333 7.06667 6.25 8H8C8.28333 8 8.521 8.096 8.713 8.288C8.905 8.48 9.00067 8.71733 9 9C8.99933 9.28267 8.90333 9.52033 8.712 9.713C8.52067 9.90567 8.28333 10.0013 8 10H4C3.71667 10 3.47933 9.904 3.288 9.712C3.09667 9.52 3.00067 9.28267 3 9V5C3 4.71667 3.096 4.47933 3.288 4.288C3.48 4.09667 3.71733 4.00067 4 4C4.28267 3.99933 4.52033 4.09533 4.713 4.288C4.90567 4.48067 5.00133 4.718 5 5V6.35C5.85 5.28333 6.88767 4.45833 8.113 3.875C9.33833 3.29167 10.634 3 12 3C13.25 3 14.421 3.23767 15.513 3.713C16.605 4.18833 17.555 4.82967 18.363 5.637C19.171 6.44433 19.8127 7.39433 20.288 8.487C20.7633 9.57967 21.0007 10.7507 21 12C20.9993 13.2493 20.762 14.4203 20.288 15.513C19.814 16.6057 19.1723 17.5557 18.363 18.363C17.5537 19.1703 16.6037 19.812 15.513 20.288C14.4223 20.764 13.2513 21.0013 12 21ZM13 11.6L15.5 14.1C15.6833 14.2833 15.775 14.5167 15.775 14.8C15.775 15.0833 15.6833 15.3167 15.5 15.5C15.3167 15.6833 15.0833 15.775 14.8 15.775C14.5167 15.775 14.2833 15.6833 14.1 15.5L11.3 12.7C11.2 12.6 11.125 12.4877 11.075 12.363C11.025 12.2383 11 12.109 11 11.975V8C11 7.71667 11.096 7.47933 11.288 7.288C11.48 7.09667 11.7173 7.00067 12 7C12.2827 6.99933 12.5203 7.09533 12.713 7.288C12.9057 7.48067 13.0013 7.718 13 8V11.6Z"
      fill="#6B6B6B"
    />
  </svg>
);

export const addMinIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 15C4.14 15 1 11.86 1 8C1 4.14 4.14 1 8 1C11.86 1 15 4.14 15 8C15 11.86 11.86 15 8 15ZM8 2C4.69 2 2 4.69 2 8C2 11.31 4.69 14 8 14C11.31 14 14 11.31 14 8C14 4.69 11.31 2 8 2Z"
      fill="#A7A7A7"
    />
    <path
      d="M8 11.5C7.72 11.5 7.5 11.28 7.5 11V5C7.5 4.72 7.72 4.5 8 4.5C8.28 4.5 8.5 4.72 8.5 5V11C8.5 11.28 8.28 11.5 8 11.5Z"
      fill="#A7A7A7"
    />
    <path
      d="M11 8.5H5C4.72 8.5 4.5 8.28 4.5 8C4.5 7.72 4.72 7.5 5 7.5H11C11.28 7.5 11.5 7.72 11.5 8C11.5 8.28 11.28 8.5 11 8.5Z"
      fill="#A7A7A7"
    />
  </svg>
);

export const fileIcon = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9997 2.6665H7.99967C7.29243 2.6665 6.61415 2.94746 6.11406 3.44755C5.61396 3.94765 5.33301 4.62593 5.33301 5.33317V26.6665C5.33301 27.3737 5.61396 28.052 6.11406 28.5521C6.61415 29.0522 7.29243 29.3332 7.99967 29.3332H23.9997C24.7069 29.3332 25.3852 29.0522 25.8853 28.5521C26.3854 28.052 26.6663 27.3737 26.6663 26.6665V9.33317L19.9997 2.6665Z"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.667 2.6665V7.99984C18.667 8.70708 18.9479 9.38536 19.448 9.88546C19.9481 10.3856 20.6264 10.6665 21.3337 10.6665H26.667"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.3337 12H10.667"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3337 17.3335H10.667"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.3337 22.6665H10.667"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const userIcon = (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 0.5C30.7696 0.5 39.5 9.23045 39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5Z"
      stroke="#6B6B6B"
    />
    <path
      d="M25.8327 27.5V25.8333C25.8327 24.9493 25.4815 24.1014 24.8564 23.4763C24.2313 22.8512 23.3834 22.5 22.4993 22.5H17.4993C16.6153 22.5 15.7674 22.8512 15.1423 23.4763C14.5172 24.1014 14.166 24.9493 14.166 25.8333V27.5"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.9993 19.1667C21.8403 19.1667 23.3327 17.6743 23.3327 15.8333C23.3327 13.9924 21.8403 12.5 19.9993 12.5C18.1584 12.5 16.666 13.9924 16.666 15.8333C16.666 17.6743 18.1584 19.1667 19.9993 19.1667Z"
      stroke="#6B6B6B"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const fileIconForDocument = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9375 1.45825H4.37496C3.98819 1.45825 3.61725 1.6119 3.34376 1.88539C3.07027 2.15888 2.91663 2.52981 2.91663 2.91659V14.5833C2.91663 14.97 3.07027 15.341 3.34376 15.6144C3.61725 15.8879 3.98819 16.0416 4.37496 16.0416H13.125C13.5117 16.0416 13.8827 15.8879 14.1562 15.6144C14.4296 15.341 14.5833 14.97 14.5833 14.5833V5.10409L10.9375 1.45825Z"
      stroke="#50869A"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.2084 1.45825V4.37492C10.2084 4.76169 10.362 5.13263 10.6355 5.40612C10.909 5.67961 11.2799 5.83325 11.6667 5.83325H14.5834"
      stroke="#50869A"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.29171 6.5625H5.83337"
      stroke="#50869A"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6667 9.47925H5.83337"
      stroke="#50869A"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.6667 12.3958H5.83337"
      stroke="#50869A"
      stroke-width="1.45833"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const clockIconForDocument = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1.3125C5.87512 1.3125 4.7755 1.64606 3.8402 2.27102C2.90489 2.89597 2.17591 3.78423 1.74544 4.82349C1.31497 5.86274 1.20233 7.0063 1.42179 8.10957C1.64124 9.21284 2.18293 10.2262 2.97834 11.0216C3.77375 11.817 4.78716 12.3588 5.89043 12.5782C6.9937 12.7977 8.13729 12.6851 9.17651 12.2545C10.2158 11.8241 11.104 11.0951 11.729 10.1598C12.354 9.22453 12.6875 8.1249 12.6875 7C12.6859 5.49207 12.0862 4.04636 11.0199 2.98009C9.95365 1.91382 8.50794 1.31409 7 1.3125ZM7 11.8125C6.04818 11.8125 5.11773 11.5303 4.32632 11.0015C3.53491 10.4726 2.91808 9.72104 2.55383 8.84163C2.18959 7.96229 2.09428 6.99466 2.27997 6.06112C2.46566 5.12759 2.92401 4.27009 3.59705 3.59705C4.27009 2.924 5.12759 2.46566 6.06113 2.27997C6.99466 2.09428 7.96229 2.18959 8.84163 2.55383C9.72104 2.91808 10.4726 3.53491 11.0015 4.32631C11.5303 5.11773 11.8125 6.04817 11.8125 7C11.811 8.27589 11.3035 9.49914 10.4014 10.4014C9.49914 11.3035 8.27589 11.811 7 11.8125ZM10.5 7C10.5 7.11606 10.4539 7.22729 10.3718 7.30933C10.2898 7.39144 10.1786 7.4375 10.0625 7.4375H7C6.88397 7.4375 6.77269 7.39144 6.69065 7.30933C6.6086 7.22729 6.5625 7.11606 6.5625 7V3.9375C6.5625 3.82147 6.6086 3.71019 6.69065 3.62814C6.77269 3.5461 6.88397 3.5 7 3.5C7.11606 3.5 7.22729 3.5461 7.30933 3.62814C7.39144 3.71019 7.4375 3.82147 7.4375 3.9375V6.5625H10.0625C10.1786 6.5625 10.2898 6.60859 10.3718 6.69064C10.4539 6.77269 10.5 6.88397 10.5 7Z"
      fill="#4A5565"
    />
  </svg>
);

export const eyeIconForDocument = (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.20284 7.20297C1.15423 7.072 1.15423 6.92793 1.20284 6.79697C1.67634 5.64888 2.48006 4.66724 3.51213 3.97649C4.54419 3.28574 5.75812 2.91699 7.00001 2.91699C8.2419 2.91699 9.45583 3.28574 10.4879 3.97649C11.52 4.66724 12.3237 5.64888 12.7972 6.79697C12.8458 6.92793 12.8458 7.072 12.7972 7.20297C12.3237 8.35105 11.52 9.33269 10.4879 10.0234C9.45583 10.7142 8.2419 11.0829 7.00001 11.0829C5.75812 11.0829 4.54419 10.7142 3.51213 10.0234C2.48006 9.33269 1.67634 8.35105 1.20284 7.20297Z"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7 8.75C7.9665 8.75 8.75 7.9665 8.75 7C8.75 6.0335 7.9665 5.25 7 5.25C6.0335 5.25 5.25 6.0335 5.25 7C5.25 7.9665 6.0335 8.75 7 8.75Z"
      stroke="white"
      stroke-width="1.16667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const shareicon=<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M11.3333 14.6666C10.7778 14.6666 10.3055 14.4721 9.91665 14.0833C9.52776 13.6944 9.33331 13.2221 9.33331 12.6666C9.33331 12.5999 9.34998 12.4444 9.38331 12.1999L4.69998 9.46658C4.5222 9.63325 4.31665 9.76392 4.08331 9.85858C3.84998 9.95325 3.59998 10.0004 3.33331 9.99992C2.77776 9.99992 2.30554 9.80547 1.91665 9.41658C1.52776 9.0277 1.33331 8.55547 1.33331 7.99992C1.33331 7.44436 1.52776 6.97214 1.91665 6.58325C2.30554 6.19436 2.77776 5.99992 3.33331 5.99992C3.59998 5.99992 3.84998 6.04725 4.08331 6.14192C4.31665 6.23659 4.5222 6.36703 4.69998 6.53325L9.38331 3.79992C9.36109 3.72214 9.34731 3.64725 9.34198 3.57525C9.33665 3.50325 9.33376 3.42259 9.33331 3.33325C9.33331 2.7777 9.52776 2.30547 9.91665 1.91659C10.3055 1.5277 10.7778 1.33325 11.3333 1.33325C11.8889 1.33325 12.3611 1.5277 12.75 1.91659C13.1389 2.30547 13.3333 2.7777 13.3333 3.33325C13.3333 3.88881 13.1389 4.36103 12.75 4.74992C12.3611 5.13881 11.8889 5.33325 11.3333 5.33325C11.0666 5.33325 10.8166 5.28592 10.5833 5.19125C10.35 5.09659 10.1444 4.96614 9.96665 4.79992L5.28331 7.53325C5.30554 7.61103 5.31954 7.68614 5.32531 7.75858C5.33109 7.83103 5.33376 7.91147 5.33331 7.99992C5.33287 8.08836 5.3302 8.16903 5.32531 8.24192C5.32042 8.31481 5.30642 8.3897 5.28331 8.46658L9.96665 11.1999C10.1444 11.0333 10.35 10.9028 10.5833 10.8086C10.8166 10.7144 11.0666 10.667 11.3333 10.6666C11.8889 10.6666 12.3611 10.861 12.75 11.2499C13.1389 11.6388 13.3333 12.111 13.3333 12.6666C13.3333 13.2221 13.1389 13.6944 12.75 14.0833C12.3611 14.4721 11.8889 14.6666 11.3333 14.6666Z" fill="#50869A"/>
</svg>
export const CCMFileIcon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.6 1.5C7.86377 1.50376 8.11537 1.61159 8.3 1.8L10.2 3.7C10.3884 3.88463 10.4962 4.13623 10.5 4.4V9.5C10.5 9.76522 10.3946 10.0196 10.2071 10.2071C10.0196 10.3946 9.76522 10.5 9.5 10.5H2.5C2.23478 10.5 1.98043 10.3946 1.79289 10.2071C1.60536 10.0196 1.5 9.76522 1.5 9.5V2.5C1.5 2.23478 1.60536 1.98043 1.79289 1.79289C1.98043 1.60536 2.23478 1.5 2.5 1.5H7.6Z"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.5 10.5V7C8.5 6.86739 8.44732 6.74021 8.35355 6.64645C8.25979 6.55268 8.13261 6.5 8 6.5H4C3.86739 6.5 3.74021 6.55268 3.64645 6.64645C3.55268 6.74021 3.5 6.86739 3.5 7V10.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.5 1.5V3.5C3.5 3.63261 3.55268 3.75979 3.64645 3.85355C3.74021 3.94732 3.86739 4 4 4H7.5"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CCMCrossICon = (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3L3 9"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 3L9 9"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ShowMoreICon = (
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.33325 8H12.6666" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8 3.33334V12.6667" stroke="#99A1AF" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
);


export const DeleteGrayIcon=<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path d="M1.75 3.5H12.25" stroke="#99A1AF" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.0834 3.5V11.6667C11.0834 12.25 10.5001 12.8333 9.91675 12.8333H4.08341C3.50008 12.8333 2.91675 12.25 2.91675 11.6667V3.5" stroke="#99A1AF" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M4.66675 3.50002V2.33335C4.66675 1.75002 5.25008 1.16669 5.83341 1.16669H8.16675C8.75008 1.16669 9.33341 1.75002 9.33341 2.33335V3.50002" stroke="#99A1AF" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.83325 6.41669V9.91669" stroke="#99A1AF" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.16675 6.41669V9.91669" stroke="#99A1AF" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"/>
</svg>